import styles from "./styles.module.scss";
import Icon from "../../../../../assets/icons";
import { useState, useEffect, useRef } from "react";

export const MoreActions = ({
  storefrontId,
  isMobile,
  setIsDeleteFoodMenu = () => {},
  setIsFoodMenuWidget = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <span className={styles.container} ref={menuRef}>
      <span
        style={{ cursor: "pointer" }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={Icon.option_alt} alt="" />
      </span>

      {isOpen ? (
        <span className={styles.dropdrown}>
          <p
            onClick={() => {
              setIsOpen(false);
              setIsDeleteFoodMenu(storefrontId);
            }}
            className="error--text"
          >
            Delete
          </p>
          <p
            onClick={() => {
              setIsOpen(false);
              setIsFoodMenuWidget(storefrontId);
            }}
          >
            {!isMobile ? "QR Code" : "Self checkout"}
          </p>
        </span>
      ) : null}
    </span>
  );
};
